import { gql } from "@apollo/client";

export const SAVE_SOCCER_PLAYER_SCORE = gql`
  mutation SaveSoccerPlayerScore($input: SoccerPlayerScoreInput!) {
    saveSoccerPlayerScore(input: $input) {
      score {
        id
        minute
        period
        actionType
        notes
        player {
          id
          fullName
        }
        relatedPlayer {
          id
          fullName
        }
        team {
          id
          name
        }
      }
    }
  }
`;

export const DELETE_SOCCER_PLAYER_SCORE = gql`
    mutation DeleteSoccerPlayerScore($scoreId: Int!) {
        deleteSoccerPlayerScore(scoreId: $scoreId) {
            success
        }
    }
`;